import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink } from 'shared/uikit';
import { ROUTES } from 'shared/constants';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationBookCreated = observer(({ notification, onClose }: PropsType) => {
    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>Новая книга</div>
            <div className={'vm-notification__description'}>
                В библиотеку знаний добавлена новая книга <UiNavLink to={ROUTES.BOOKS(notification.data.book.id)} onClick={onClose}>{notification.data.book.name}</UiNavLink>
            </div>
        </div>
    );
})
